import {
  Popover,
  PopoverTrigger,
  Tag,
  Portal,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  Text,
} from '@chakra-ui/react';
import { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { Icons, defaultIconSize } from '../Icons';

export function MirrorTag({
  mainSupplier,
  containerRef,
}: {
  mainSupplier: { name: string; branch: string };
  containerRef?: RefObject<HTMLDivElement>;
}) {
  const { t } = useTranslation();
  return (
    <Popover trigger="hover" variant="tooltip">
      <PopoverTrigger>
        <Tag
          width="fit-content"
          size="sm"
          color="white"
          bg="gray.500"
          _light={{
            bg: 'gray.300',
          }}
        >
          <Icons.Link boxSize={defaultIconSize} />
        </Tag>
      </PopoverTrigger>
      <Portal containerRef={containerRef}>
        <PopoverContent>
          <PopoverArrow />
          <PopoverBody>
            <Text variant="sub">
              {t('variant.supplier.mirrorBranchSupplier', {
                supplier: mainSupplier.name,
                branch: mainSupplier.branch,
              })}
            </Text>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}
